import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { RESOLUTION_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const resolutionTransformer = (resolution) => {
	if (resolution == null) return null;

	return {
		id: resolution.resolutionId,
		name: resolution.name || '',
	};
};

export const transformAggResolutionToLegacyField: FieldTransformer<typeof RESOLUTION_TYPE> = (
	node,
) => {
	if (node.type !== RESOLUTION_TYPE) return undefined;

	const value = resolutionTransformer(node.resolution);
	// @ts-expect-error: node.resolutions does not exist in jiraIssueFieldsFragmentLegacyRedux. These transformations will be deleted when IV is migrated to Relay
	const allowedValues = transformAggConnection(node.resolutions, resolutionTransformer);

	return {
		...transformAggNodeToLegacyField(node),
		value,
		allowedValues,
		schema: {
			type: RESOLUTION_TYPE,
			renderer: PLAIN_TEXT,
			custom: null,
			system: RESOLUTION_TYPE,
			items: null,
			configuration: null,
		},
	};
};
